module.exports = __webpack_public_path__ + "img/dog_hero.95c35833.svg";